require.ensure(
    ["./vue_search", "./bootstrap"],
    function() {
        window.$ = window.jQuery = require("jquery");
        require("./vue_search");
        require("./bootstrap");

        jQuery.ready.then(function() {
            $(".thumbnail.product-listing").on({
                mouseenter: function() {
                    $(this)
                        .parent()
                        .css("height", $(this).innerHeight() + "px");
                    $(this)
                        .find("img[data-hover-src]")
                        .each(function() {
                            $(this)
                                .attr("src", $(this).data("hover-src"))
                                .removeData("hover-src");
                        });
                    $(this).addClass("hovering");
                },
                mouseleave: function() {
                    $(this).removeClass("hovering");
                    $(this)
                        .parent()
                        .css("height", null);
                }
            });
        });
    },
    "search_bootstrap"
);
